import { render } from "./MixTypeProperties.vue?vue&type=template&id=758321ed&ts=true"
import script from "./MixTypeProperties.vue?vue&type=script&lang=ts"
export * from "./MixTypeProperties.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__